<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" class="bgImg" />
      <div>预定酒店</div>
    </div>
    <div class="searchBox">
      <van-search
        class="searchInner"
        v-model="keyword"
        shape="round"
        placeholder="搜索酒店名称"
        @search="onSearch"
        @input="onSearch"
      />
      <div class="selectBox" @click.stop="show = true">
        <span>{{ hotelType }}</span>
        <span class="iconfont icon-arrow-down"></span>
      </div>
    </div>
    <!-- 酒店列表 -->
    <div v-if="list != null && list.length > 0">
      <div v-for="(item, index) in list" :key="index">
        <div class="hasData">
          <div class="contentBox">
            <div class="imgBox">
              <img :src="item.Cover" alt="" />
              <div>{{ item.Type }}</div>
            </div>
            <div class="hotelContent">
              <div class="hotelName">{{ item.Name }}</div>
              <div class="priceBox">
                <div
                  class="priceItem"
                  v-for="(pitem, pindex) in item.PriceList"
                  :key="pindex"
                >
                  <div class="priceLeft">
                    <span>￥</span>
                    <span>{{ pitem.Price }}</span>
                  </div>
                  <div class="priceRight">{{ pitem.Desc }}</div>
                </div>
                <div class="borderR" v-if="item.PriceList.length > 1"></div>
              </div>
            </div>
          </div>
          <div class="contentItem">酒店地址：{{ item.Address }}</div>
          <div class="contentItem">交通指引：{{ item.TrafficGuidelines }}</div>
          <div class="callSub">
            <div>
              <div class="contentItem">酒店服务：{{ item.HotelService }}</div>
              <div class="contentItem">
                备注：{{ item.Remarks ? item.Remarks : "暂无" }}
              </div>
            </div>
            <div class="callPhone" @click.stop="callClick">
              <div class="iconfont icon-dianhua"></div>
              <div>电话预订</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noDataBox" v-else>
      <span class="iconfont icon-kong"></span>
      <div>暂无搜索结果，更换关键词试试吧</div>
    </div>
    <!-- 酒店类型 -->
    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
      @select="onSelect"
    ></van-action-sheet>
    <!-- 电话预定 -->
    <van-action-sheet v-model="showCall">
      <div class="callBox">
        <div class="callItem">
          <a href="tel:020-36047679">020-36047679</a>
        </div>
        <div class="callItem">
          <a href="tel:18688396882">胡先生 18688396882 </a>
        </div>
        <div class="line"></div>
        <div class="callItem cancel" @click="cancelCall">取消</div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import { Search, ActionSheet } from "vant";
import { getExhibitionHotelList } from "@/api/index";
export default {
  name: "expoHotel",
  components: {
    "van-action-sheet": ActionSheet,
    "van-search": Search,
  },
  data() {
    return {
      keyword: "",
      show: false,
      showCall: false,
      list: [],
      type: "",
      hotelType: "酒店类型",
      actions: [
        { name: "五星级" },
        { name: "准五星级" },
        { name: "四星级" },
        { name: "三星级" },
        { name: "商务及公寓" },
        { name: "不限" },
      ],
    };
  },
  methods: {
    //电话预定
    callClick() {
      this.showCall = true;
    },

    //取消电话
    cancelCall() {
      this.showCall = false;
    },

    //取消
    onCancel() {},

    //选择
    onSelect(item) {
      this.hotelType = item.name;
      var name = "";
      if (item.name == "不限") {
        name = "";
      } else {
        name = item.name;
      }
      this.type = name;
      this.getList();
    },

    //搜索
    onSearch() {
      this.getList();
    },

    //获取酒店列表
    getList() {
      var that = this;
      getExhibitionHotelList({
        Type: that.type,
        Name: that.keyword,
      }).then((res) => {}, (err) => {
        that.list = err.List && err.List.length > 0 ? err.List : [];
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="less" scoped >
.container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 40px;
}

.top-box {
  width: 375px;
  height: 103px;
  position: relative;
  div {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 23px;
    font-weight: bold;
  }
}

.bgImg {
  width: 100%;
  height: 100%;
}

.searchBox {
  display: flex;
  align-items: center;
  background-color: #fff;
  .searchInner {
    width: 280px;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-radius: 18px;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
    /deep/ .van-search__content {
      background-color: #f5f5f5;
    }
  }
}

.selectBox {
  font-size: 12px;
  color: #666;
  width: 94px;
  height: 40px;
  background: #ffffff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 12px;
    margin-left: 5px;
  }
}

.hasData {
  padding: 12px 10px 0px 10px;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 10px;
}

.contentBox {
  display: flex;
  margin-bottom: 10px;
}

.imgBox {
  position: relative;
  width: 100px;
  height: 132px;
  border-radius: 4px;
  background-color: #f5f5f5;
  img {
    width: 100px;
    height: 132px;
    border-radius: 4px;
    background-color: #f5f5f5;
  }
  div {
    position: absolute;
    left: 0px;
    top: 0px;
    padding: 0px 4px;
    height: 20px;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 4px 0px 0px 0px;
    color: #fff;
    font-size: 11px;
    text-align: center;
  }
}

.hotelName {
  font-size: 18px;
  font-weight: 600;
}

.priceBox {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 6px;
  margin-top: 41px;
  position: relative;
}

.priceItem {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.borderR {
  width: 1px;
  background-color: #f5f5f5;
  height: 44px;
  position: absolute;
  left: 50%;
  top: 8px;
}

.hotelContent {
  width: 225px;
  margin-left: 10px;
}

.priceLeft {
  color: #d62f2f;
  font-weight: 600;
  span:nth-child(1) {
    font-size: 16px;
  }
  span:nth-child(2) {
    font-size: 24px;
  }
}

.priceRight {
  font-size: 12px;
}

.contentItem {
  font-size: 12px;
  color: #666660;
  margin-bottom: 7px;
  line-height: 20px;
}

.callSub {
  display: flex;
  justify-content: space-between;
  .callPhone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #d62f2f;
    font-size: 10px;
    .iconfont {
      font-size: 14px !important;
      margin-bottom: 8px;
    }
  }
}

.callBox {
  font-size: 17px;
  color: #000;
  .line {
    height: 8px;
    background: #f2f2f2;
  }
  .callItem {
    height: 56px;
    line-height: 56px;
    text-align: center;
    &:nth-child(1) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.03);
    }
    a {
      color: #000 !important;
    }
  }
}
</style>
